import { useState } from "react";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { toast } from "react-toastify";
import "./MusicActions.css";
import { Tooltip } from "@mui/material";

function ToggleLockSongs({ event, onToggle }: { event: any; onToggle?: (locked: boolean) => void }) {
  const [isLocked, setIsLocked] = useState<boolean>(!!event?.lock_songs);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

const handleToggle = async () => {
  const action = isLocked ? "unlock" : "lock";
  const confirmed = window.confirm(`Are you sure you want to ${action} songs for this event?`);
  if (!confirmed) return;

  setLoading(true);
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/events/toggle-song-lock/${event.id}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ lock_songs: !isLocked }),
      }
    );
    const result = await response.json();
    if (!response.ok) {
      toast.warn(result.message || "Failed to update lock status");
      return;
    }
    const newLocked = result.data?.lock_songs !== undefined ? !!result.data.lock_songs : !isLocked;
    setIsLocked(newLocked);
    onToggle?.(newLocked);
    toast.info(`Songs ${newLocked ? "locked" : "unlocked"} successfully`);
  } catch (error) {
    console.error("Error deleting song:", error);
    alert("Failed to toggle lock song. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <Tooltip title={
      isLocked
          ? "Unlock to allow directors to upload or delete songs."
          : "Lock to prevent directors from uploading or deleting songs."
      }
    >
      <button
        onClick={handleToggle}
        disabled={loading}
        className="toggle-lock-button"
        data-loading={loading}
      >
        {isLocked
          ? <LockOpenIcon className="lock-icon unlocked" />
          : <LockIcon className="lock-icon locked" />}
        <span>{isLocked ? "Unlock Uploads & Delete" : "Lock Uploads & Delete"}</span>
      </button>
    </Tooltip>
  );
}

export default ToggleLockSongs;